import { useEffect, useRef } from 'react';
import type { FlatList } from 'react-native';
import { useSafeTimeout } from '../../../../../../hooks';

type UseScrollFilterWhenClickChipProps = {
  targetIndex: number | undefined;
  dataLength: number;
  listRef: React.RefObject<FlatList | null>;
};

/**
 * - 아토믹에서 FILTER_LIST의 칩을 클릭한 후 바텀시트가 열리면서 클릭한 칩이 바텀시트의 맨 위에 오게하는 훅
 */
export const useScrollFilterWhenClickChip = ({
  targetIndex,
  dataLength,
  listRef,
}: UseScrollFilterWhenClickChipProps) => {
  // 바텀시트가 열려있는 동안에는 한번 실행 후 다시 실행되면 안되기 때문에 해당 ref가 필요하다.
  const isInitialScrolled = useRef(false);
  const setSafeTimeout = useSafeTimeout();

  useEffect(() => {
    if (
      targetIndex === undefined ||
      !listRef.current ||
      isInitialScrolled.current ||
      dataLength === 0
    ) {
      return;
    }

    const safeIndex = Math.min(targetIndex, dataLength - 1);

    setSafeTimeout(() => {
      listRef.current?.scrollToIndex({
        index: safeIndex,
        animated: true,
      });
    }, 300);

    isInitialScrolled.current = true;
  }, [listRef, targetIndex, dataLength, setSafeTimeout]);
};
